import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const API_KEYS_PATH = '/api/api-keys';

const createApiKey = async (keyData) => {
  const response = await axios.post(`${API_BASE_URL}${API_KEYS_PATH}`, keyData);
  return response.data; // Return the full response { success, key, data }
};

const getApiKeys = async () => {
  const response = await axios.get(`${API_BASE_URL}${API_KEYS_PATH}`);
  return response.data.data;
};

const revokeApiKey = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}${API_KEYS_PATH}/${id}`);
  return response.data.data;
};

const apiKeyService = {
  createApiKey,
  getApiKeys,
  revokeApiKey,
};

export default apiKeyService;